import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import {
  motion,
  useScroll,
  useTransform,
  useSpring,
  useReducedMotion,
} from 'framer-motion'

const UIbars = (props) => {
  const theme = props.theme ? props.theme : 'default'
  const display = props.display ? props.display : 'both'
  const isEvenBlock = props.index % 2 == 0 ? true : false
  const prefersReducedMotion = useReducedMotion()
  const { scrollYProgress } = useScroll({
    target: props.container,
    offset: ['-20%', '100%'],
  })
  const translateY = useSpring(scrollYProgress, {
    stiffness: 70,
    damping: 30,
  })
  const leftUIAnim = useTransform(translateY, [0, 1], [200, 500])
  const rightUIAnim = useTransform(translateY, [0, 1], [200, -500])

  return (
    <>
      {!isEvenBlock && (
        <>
          {display !== 'right' && (
            <motion.div
              style={{
                y: !prefersReducedMotion && leftUIAnim,
              }}
              className={`gatsby-absolute pointer-events-none z-20 left-2 lg:left-4 xxl:left-12 ${theme === 'dreadshore' ? '-top-48' : 'top-0'}`}
            >
              {theme === 'dreadshore' ? (
                <StaticImage
                  src="../../assets/img/MyM-ui-bar-red.png"
                  alt=""
                  className="h-auto w-4 lg:w-8 xxl:w-12"
                  loading="lazy"
                />
              ) : (
                theme === 'shattered-peak' ? (
                  <StaticImage
                    src="../../assets/img/MyM-ui-bar-orange.png"
                    alt=""
                    className="h-auto w-4 lg:w-8 xxl:w-12"
                    loading="lazy"
                  />
                ) : (
                  <StaticImage
                    src="../../assets/img/MyM-ui-bar.png"
                    alt=""
                    className="h-auto w-4 lg:w-8 xxl:w-12"
                    loading="lazy"
                  />
                )
              )}
            </motion.div>
          )}
          {display !== 'left' && (
            <motion.div
              style={{
                y: !prefersReducedMotion && rightUIAnim,
              }}
              className={`gatsby-absolute pointer-events-none  top-0 z-20 right-2 lg:right-4 xxl:right-12`}
            >
              {theme === 'dreadshore' ? (
                <StaticImage
                  src="../../assets/img/MyM-ui-bar-red.png"
                  alt=""
                  className="h-auto w-4 lg:w-8 xxl:w-12"
                  loading="lazy"
                />
              ) : (
                theme === 'shattered-peak' ? (
                  <StaticImage
                    src="../../assets/img/MyM-ui-bar-orange.png"
                    alt=""
                    className="h-auto w-4 lg:w-8 xxl:w-12"
                    loading="lazy"
                  />
                ) : (
                  <StaticImage
                    src="../../assets/img/MyM-ui-bar.png"
                    alt=""
                    className="h-auto w-4 lg:w-8 xxl:w-12"
                    loading="lazy"
                  />
                )
              )}
            </motion.div>
          )}
        </>
      )}
    </>
  )
}

export default UIbars
